import React from 'react'
import CommonInformationList from '../../../common/pages/secure/InformationList'
import Config from '../../../Config'
import PageHeader from '../../components/PageHeader'

class InformationList extends CommonInformationList {
  constructor (props) {
    super(props)
    this.apiUrl = Config.companyUserApiUrl.systemSettings
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
  }
  renderPageNavi () {
    return (
      <PageHeader title='事務局からのお知らせ一覧' sub='こちらから事務局からのお知らせを確認できます。' history={this.props.history} />
    )
  }
}

export default InformationList



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/InformationList.js